import { Component, Prop, Ref, log, useProp } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';


import './ContactMain.scss';

@Component
export class ContactMain extends ThemeComponent {

}
